import React, { useState, useEffect } from "react";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import "./styles/Verification.css";
import { HalfBox } from "../components/scripts/HalfBox";
import { ApiCall } from "../utility/ApiCalls";
import Loader from "react-loader-spinner";
import {
  BrowserRouter as Router,
  useLocation,
  Switch,
  Route,
} from "react-router-dom";

// const TestURL = () => {
//   console.log('Inside Test URL ');
//   const { search } = useLocation();
//   useEffect(() => {
//     const urlParams = Object.fromEntries([...new URLSearchParams(search)]);
//     console.log('URL Params ', urlParams);
//   }, [search]);
// };

//function VerificationCR() {
export default function VerificationCR() {
  const [isLoading, setLoading] = useState(true);
  const [ocrData, setOCRData] = useState([]);
  const [displayReady, setDisplayReady] = useState(false);
  const [displayReadyActiveTask, setDisplayReadyActiveTask] = useState(false);
  const [displayReadyFax, setDisplayReadyFax] = useState(false);
  const [activeTaskData, setActiveTaskData] = useState([]);
  const [ocrDataCPT, setCPTData] = useState([]);
  const [ocrDataDX, setDXData] = useState([]);
  const [ocrDataProvider, setProviderData] = useState([]);
  const [umreviewType, setUMReviewType] = useState([]);
  const [admissionSource, setAdmissionSource] = useState([]);
  const [admissionType, setAdmissionType] = useState([]);
  const [requestProfile, setRequestProfile] = useState([]);
  const [selectedUMreviewType, setUMReviewTypeSelected] = useState("");
  const [selectedAdmissionSource, setAdmissionSourceSelected] = useState("");
  const [selectedAdmissionType, setAdmissionTypeSelected] = useState("");
  const [selectedRequestProfile, setSelectedRequestProfile] = useState("");
  const [selectedUMReviewTypeData, setSelectedUMReviewTypeData] = useState("");
  const [requestProfileData, setRequestProfileData] = useState("");
  const [coords, setCoords] = useState("");
  const [taskStatus, setTaskStatus] = useState();
  const [completedTime, setCompletedTime] = useState();
  const [taskID, setTaskID] = useState("3346722");
  const [fax, setFax] = useState();
  // API CALL FUNCTION DECLARATION  ============================================================

  async function getvalidatedtask(e) {
    console.log("Going to call validatedtask Api ");
    const ret = await ApiCall(
      {
        //taskID: sessionStorage.getItem("ActiveTaskID"),
        taskID: taskID,
      },
      "vcare-ui",
      "agent_getvalidatedtask"
    );
    setTaskStatus(ret.body.Status);
    setCompletedTime(ret.body.Status);
  }

  async function getOCRDatafromAPI() {
    const retAssigned = await ApiCall(
      {
        taskID: taskID,
      },
      "vcare-ui",
      "agent_getvalidatedtask"
      // "agent_gettaskdetails"
    );

    const response = retAssigned.body;

    if (response.CPTCodes != null) {
      setCPTData(response.CPTCodes);
    }
    if (response.DiagnosisCodes != null) {
      setDXData(response.DiagnosisCodes);
    }
    if (response.Providers != null) {
      setProviderData(response.Providers);
    }
    setOCRData(response);

    setSelectedUMReviewTypeData(response.UMReviewType);
    setRequestProfileData(response.RequestProfile);
    return true;
  }

  async function getActiveTaskfromAPI() {
    // const retActive = await ApiCall(
    //   {
    //     requestType: "Agent",
    //     filterType: "",
    //     status: "T02",
    //     agentID: sessionStorage.getItem("UserID"), //GET ID from SESSION
    //     supervisorID: ""
    //   },
    //   "vcare-ui",
    //   "tasklist"
    // );
    // const response = retActive.body;
    // setActiveTaskData(response);
    // if (retActive.statusCode == "200") {
    setDisplayReadyActiveTask(true);
    // }
  }

  async function getUMReviewTypefromAPI() {
    // const retActive = await ApiCall("", 'vcare-ui', 'vcare_umreviewtype');
    const retActive = await ApiCall("", "vcare-ui", "vcare_getumreviewtype");
    const response = retActive.body;
    setUMReviewType(response);

    const retAdmissionSource = await ApiCall(
      "",
      "vcare-ui",
      "vcare_getadmissionsource"
    );
    const response2 = retAdmissionSource.body;
    setAdmissionSource(response2);

    const retAdmissionType = await ApiCall(
      "",
      "vcare-ui",
      "vcare_getadmissiontype"
    );
    const response3 = retAdmissionType.body;
    setAdmissionType(response3);

    const getRequestProfile = await ApiCall(
      "",
      "vcare-ui",
      "vcare_requestprofile"
    );
    const response4 = getRequestProfile.body;
    setRequestProfile(response4);
  }

  async function getFaxfromAPI() {
    const response = await ApiCall(
      {
        taskID: taskID,
      },
      "vcare-ui",
      "agent_gettaskdetails/getfax"
      //"agent_gettaskdetails/zone2_getfax" // QA instance
      //"agent_gettaskdetails/demo_getfax" // Demo instance
    );

    setFax(response);
    if (response != undefined) {
      setDisplayReadyFax(true);
    }
  }

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const getHeightAndWidthOfElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (!element) {
      return {
        width: 0,
        height: 0,
      };
    }
    return {
      width: element.getBoundingClientRect().width,
      height: element.getBoundingClientRect().height,
    };
  };

  function LoadContent() {
    if (ocrData.length != 0) {
      setDisplayReady(true);
    }
  }

  useEffect(() => {
    const temp = window.location.search;
    const ID = temp.split("=")[1];
    console.log("temp value ", ID);
  }, []);

  useEffect(() => {
    getvalidatedtask();
    getOCRDatafromAPI();
    getActiveTaskfromAPI();
    getUMReviewTypefromAPI();
    getFaxfromAPI();
  }, []);

  useEffect(() => {
    LoadContent();
  }, [ocrData]);

  useEffect(() => {
    if (displayReady && displayReadyActiveTask && displayReadyFax) {
      setLoading(false);
    }
  }, [displayReady, displayReadyActiveTask, displayReadyFax]);

  if (isLoading) {
    return (
      <div>
        {/* <div className="content-container">
          <div className="div-loading">
            <Loader type="Puff" color="#00BFFF" height={100} width={100} />
          </div>
        </div> */}
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      </div>
    );
  } else {
    return (
      <>
        <Box className="primary-title-new">
          <img src="img/heading-bg.png" />
          <Typography variant="h1">
            Utilization Management - <span> Intake Verification</span>
          </Typography>
        </Box>
        <div className="verification-content-main">
          <div className="content-container halfbox-container">
            <HalfBox
              fax={fax}
              coords={coords}
              ocrData={ocrData}
              taskData={activeTaskData}
              setOCRData={setOCRData}
              selectedUMReviewTypeData={selectedUMReviewTypeData}
              requestProfileData={requestProfileData}
              dxData={ocrDataDX}
              setDXData={setDXData}
              cptData={ocrDataCPT}
              setCPTData={setCPTData}
              providerData={ocrDataProvider}
              setProviderData={setProviderData}
              umReviewTypeCB={umreviewType}
              admissionSourceCB={admissionSource}
              requestProfileCB={requestProfile}
              admissionTypeCB={admissionType}
              selectedUMreviewType={selectedUMreviewType}
              setUMReviewTypeSelected={setUMReviewTypeSelected}
              selectedAdmissionSource={selectedAdmissionSource}
              setAdmissionSourceSelected={setAdmissionSourceSelected}
              selectedAdmissionType={selectedAdmissionType}
              setAdmissionTypeSelected={setAdmissionTypeSelected}
              selectedRequestProfile={selectedRequestProfile}
              setSelectedRequestProfile={setSelectedRequestProfile}
              loading={isLoading}
              setLoading={setLoading}
              taskStatus={taskStatus}
              completedTime={completedTime}
              getOCRDatafromAPI={getOCRDatafromAPI}
            ></HalfBox>
          </div>
        </div>
      </>
    );
  }
}
